import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FilesystemService } from "./services/filesystem.service";

@NgModule({
	declarations: [],
	imports: [CommonModule],
	providers: [FilesystemService]
})
export class FilesystemModule {}
